import { Code } from '@clearkit/icons';

import { APIPage } from '~/components/api/APIPage';
import { PageLayout } from '~/components/PageLayout';

export const PageAPIKeys = () => (
  <PageLayout>
    <PageLayout.Header>
      <PageLayout.Tile>
        <Code />
      </PageLayout.Tile>
      <PageLayout.Heading>Keys & Settings</PageLayout.Heading>
      <PageLayout.SubHeading>
        Manage your API & Developer settings
      </PageLayout.SubHeading>
    </PageLayout.Header>
    <PageLayout.Body>
      <PageLayout.Content>
        <APIPage />
      </PageLayout.Content>
    </PageLayout.Body>
  </PageLayout>
);
